/**
 * 应用顶级容器
 * @author luoying
 * @since 17/10/17
 */

import { connect } from 'react-redux';
import Store from 'components/store/store';

const mapStateToProps = state => ({ user: state.userInfo });

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Store);
